import type {GroupedUnplannedDelivery} from '@domain/material-storage/src/types'
import {ApiClient} from '@hconnect/apiclient'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const UnplannedDeliveriesQueryKey = 'materialUnplannedDeliveries'

type Params = {
  plantCode: string
  materialId: number
  from?: string
  to?: string
  options?: Omit<UseQueryOptions<GroupedUnplannedDelivery[], AxiosError>, 'queryKey' | 'queryFn'>
}

export const useUnplannedDeliveriesQuery = ({plantCode, materialId, from, to, options}: Params) =>
  useQuery<GroupedUnplannedDelivery[], AxiosError>({
    queryKey: [UnplannedDeliveriesQueryKey, plantCode, materialId, from, to],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<GroupedUnplannedDelivery[]>(
        `/plants/${plantCode}/material-orders/daily-unplanned-deliveries`,
        {params: {from, to, materialId}, signal}
      )
      return response.data
    },
    ...options
  })
